import type { ConversationAttachment } from 'src/graphql/entities/conversation/conversation.types';
import type { MoveAttachmentToSiteFilesAttachment } from 'src/graphql/entities/files-upload.types';

export const getMoveAttachmentToSiteFilesPayload = (
  attachment: ConversationAttachment,
): MoveAttachmentToSiteFilesAttachment => ({
  id: attachment.id,
  partnerId: attachment.partnerId,
  fileKey: attachment.fileKey,
  fileName: attachment.fileName,
  contentType: attachment.contentType,
  size: attachment.size,
});
